import { trigger, animate, style, group, query, transition, stagger } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
    transition('* <=> *', [
        // query(':enter, :leave',
        //     style({
        //         opacity: 0
        //     }), { optional: true }
        // ),
        group([
            query(':enter', [
                style({
                    opacity: 0
                }),
                animate('0.5s ease-in', style({ opacity: 1 }))
                // stagger(600, [
                // ])
            ], { optional: true }),
            query(':leave', [
                style({
                    opacity: 1
                }),
                animate('0.5s ease-out', style({ opacity: 0 }))
            ], { optional: true }),
        ])
    ])
])


// WEBPACK FOOTER //
// ./src/app/services/animations/router.animation.ts